(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.getConfig = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.getClientConfig = getClientConfig;
  _exports.getConfig = getConfig;
  //
  // https://github.axa.com/AXA-GS-ASIA/env-config/blob/master/src/index.js?

  function getConfig(value, type, description) {
    let isRequired = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    if (value.toUpperCase() !== value) {
      throw new Error("the environment variable should be all capitalized. ".concat(value, " has lower case values"));
    }
    const envVar = process.env[value];
    const desc = description ? "\n================== description ==================\n".concat(description, "\n=================================================\n  ") : '';
    if (typeof envVar === 'undefined' && isRequired) {
      throw new Error("environment variable <".concat(value, "> is required. ").concat(desc));
    }
    if (typeof envVar === 'undefined') {
      return undefined;
    }
    if (type === 'boolean') {
      if (envVar.toLowerCase() === 'true') {
        return true;
      } else if (envVar.toLowerCase() === 'false') {
        return false;
      }
      throw new Error("environment variable <".concat(value, "> is defined as a boolean but \"").concat(envVar, "\" is neither true or false. ").concat(desc));
    } else if (type === 'string') {
      return envVar;
    } else if (type === 'number') {
      const num = Number(envVar);
      if (isNaN(num)) {
        throw new Error("environment variable <".concat(value, "> is defined as a number but \"").concat(envVar, "\" is not a number. ").concat(desc));
      } else {
        return num;
      }
    } else if (type === 'json') {
      try {
        return JSON.parse(envVar);
      } catch (e) {
        throw new Error("environment variable <".concat(value, "> is defined as a json but \"").concat(envVar, "\" is not a json. ").concat(desc));
      }
    }
    throw new Error("type (2nd argument) should be enum of boolean|string|number|json but got ".concat(type));
  }
  function getClientConfig() {
    if (typeof window !== 'undefined' && window.__client_configs__) {
      // eslint-disable-line
      return window.__client_configs__; // eslint-disable-line
    }
    return false;
  }
});